import React, { useRef } from 'react';
import { useEffect } from 'react';
import styled from 'styled-components';

const Modal = ({ open, children, onRequestClose }) => {
  const backgroundRef = useRef();

  useEffect(() => {
    if (open) {
      const scrollBarWidth = window.innerWidth - document.body.clientWidth + 'px';
      document.body.style.overflow = "hidden";
      document.body.style.paddingRight = scrollBarWidth;
    } else {
      document.body.style.overflow = "unset";
      document.body.style.paddingRight = "0";
    }
  }, [open])

  const onModalClick = (e) => {
    if (e.target === backgroundRef.current) {
      onRequestClose();
    }
  }

  if (!open) {
    return null;
  }

  return (
    <ModalBackground ref={backgroundRef} onClick={onModalClick}>
      <ModalContainer>{children}</ModalContainer>
    </ModalBackground>
  );
};

const ModalContainer = styled.div`
  z-index: 1;
  background-color: white;
`;

const ModalBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  
  background-color: rgba(56, 56, 71, 0.5);
`;

export default Modal;
